<template>
  <aside
    v-if="relatedItems.length"
    class="news-related"
    aria-labelledby="news-related-heading"
  >
    <h2 id="news-related-heading" class="news-related__title">
      Другие новости
    </h2>
    <ul class="news-related__list">
      <li
        v-for="item in relatedItems"
        :key="item.id"
        class="news-related__item"
      >
        <router-link
          class="news-related__link"
          :to="{ name: 'NewsItem', params: { id: item.id } }"
        >
          <div class="news-related__thumb">
            <img
              v-if="item.imageUrl"
              class="news-related__thumb-img"
              :src="item.imageUrl"
              :alt="item.title || ''"
              loading="lazy"
            >
            <div v-else class="news-related__thumb-empty" aria-hidden="true" />
          </div>
          <div class="news-related__meta">
            <time
              v-if="formatDate(item.dateTime)"
              class="news-related__date"
              :datetime="item.dateTime"
            >
              {{ formatDate(item.dateTime) }}
            </time>
            <span class="news-related__item-title">{{ item.title }}</span>
          </div>
        </router-link>
      </li>
    </ul>
    <router-link class="news-related__all" :to="{ name: 'News' }">
      Все новости
    </router-link>
  </aside>
</template>

<script>
import NewsAPi from '@/api/news.js'

const RELATED_LIMIT = 3

export default {
  name: 'NewsRelatedList',
  props: {
    currentId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      allNews: [],
    }
  },
  computed: {
    relatedItems() {
      const current = String(this.currentId || '')
      return (this.allNews || [])
        .filter((item) => item && item.id && String(item.id) !== current)
        .slice(0, RELATED_LIMIT)
    },
  },
  watch: {
    currentId() {
      this.loadNews()
    },
  },
  mounted() {
    this.loadNews()
  },
  methods: {
    formatDate(value) {
      if (!value) return ''
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) {
        const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
        if (m) {
          return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString(
            'ru-RU',
            { day: 'numeric', month: 'long', year: 'numeric' }
          )
        }
        return ''
      }
      return d.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    },
    async loadNews() {
      try {
        const response = await NewsAPi.getNews()
        if (response.data && response.data.status === 'SUCCESS' && Array.isArray(response.data.result)) {
          this.allNews = response.data.result
        }
      } catch (e) {
        console.warn('NewsRelatedList: не удалось загрузить список новостей', e)
      }
    },
  },
}
</script>
